/**
 * Logikk for Nordic Standard for Psychosocial Work Environment
 * Definerer krav, sertifiseringsnivåer og poengberegning.
 */

export const standardPrinciples = [
  { id: 'respect', name: 'Respekt', icon: 'Smile', desc: 'Gjensidig anerkjennelse og verdighet i alle ledd.' },
  { id: 'trust', name: 'Tillit', icon: 'Heart', desc: 'Tro på intensjoner og kompetanse hos kolleger.' },
  { id: 'safety', name: 'Psykologisk Trygghet', icon: 'Shield', desc: 'Trygghet for å feile og ytre seg uten frykt.' },
  { id: 'leadership', name: 'Rettferdig Ledelse', icon: 'Award', desc: 'Forutsigbarhet, støtte og objektivitet.' },
  { id: 'comm', name: 'Åpen Kommunikasjon', icon: 'MessageCircle', desc: 'Gjennomsiktighet og aktiv lytting.' },
  { id: 'workload', name: 'Bærekraftig Belastning', icon: 'Wind', desc: 'Balanse mellom krav og ressurser.' }
];

export const certificationRequirements = [
  {
    id: 'req-1',
    level: 1,
    title: 'Basic Compliance',
    requirements: [
      { id: 'r1a', text: 'Årlig arbeidsmiljøkartlegging gjennomført', weight: 25 },
      { id: 'r1b', text: 'Skriftlige rutiner for konflikthåndtering', weight: 25 },
      { id: 'r1c', text: 'Lovpålagt HMS-opplæring for ledere', weight: 25 },
      { id: 'r1d', text: 'Etablert system for avviksmelding', weight: 25 }
    ]
  },
  {
    id: 'req-2',
    level: 2,
    title: 'Advanced Practices',
    requirements: [
      { id: 'r2a', text: 'Kvartalsvise pulsmålinger av team-helse', weight: 25 },
      { id: 'r2b', text: 'Lederutviklingsprogram med fokus på relasjon', weight: 25 },
      { id: 'r2c', text: 'Implementert metodikk for psykologisk trygghet', weight: 25 },
      { id: 'r2d', text: 'Dokumentert medvirkning i endringsprosesser', weight: 25 }
    ]
  },
  {
    id: 'req-3',
    level: 3,
    title: 'Excellence in Culture',
    requirements: [
      { id: 'r3a', text: 'Benchmark-score i topp 10% i bransjen', weight: 25 },
      { id: 'r3b', text: 'Integrert arbeidsmiljø som KPI i årsrapport', weight: 25 },
      { id: 'r3c', text: 'Sertifiserte interne fasilitatorer', weight: 25 },
      { id: 'r3d', text: 'Innovasjonsrate korrelert med trygghetsscore', weight: 25 }
    ]
  }
];

export const calculateLevelStatus = (completedIds) => {
  const status = certificationRequirements.map(lvl => {
    const sectionIds = lvl.requirements.map(r => r.id);
    const completedInSection = completedIds.filter(id => sectionIds.includes(id)).length;
    const progress = (completedInSection / lvl.requirements.length) * 100;
    return { ...lvl, progress, isComplete: progress === 100 };
  });

  let currentLevel = 0;
  if (status[0].isComplete) currentLevel = 1;
  if (status[0].isComplete && status[1].isComplete) currentLevel = 2;
  if (status[0].isComplete && status[1].isComplete && status[2].isComplete) currentLevel = 3;

  return { status, currentLevel };
};